module.exports = __webpack_public_path__ + "img/7A.f601b505.png";